<template>
    <div>

        <video
                :style="{height:height+'px'}"
                autoplay
                x-webkit-airplay='true'
                webkit-playsinline='true'
                playsinline='true'
                controls
                :src="src"
                :poster="poster"
                ref="video"
                x5-video-player-type="h5-page"
        ></video>

    </div>

</template>

<script>
    export default {
        name: 'layVideo',
        props: {
            src: String,
            poster: String,
            height: Number,
            playEndFun: Function
        },
        data: function () {
            return {
                getTimeInterval: false,
                percent: 0,//百分比
                duration: 0,//视频总时长
                currentTime: 0,//当前播放进度
                error: false,
                duration_slider_time: "0:00",
                currentTime_slider_time: "0:00",
                current_slider: 0,//当前播放进度
                buffered_slider: 0,//缓冲进度
                playing: false,//视频是否在播放
                loadding: true,//显示加载loading
                isfirsttime: true,
                errorTimer:false,//视频错误

            }
        },
        created: function () {
            if (!this.height) {
                this.height = 300
            }
            this.muted = this.pmuted;


        },
        watch: {
            src(src){
                if(this.errorTimer){
                    clearTimeout(this.errorTimer)
                }
                setTimeout(()=>{
                    try{
                        this.$refs.video.load();
                        this.$refs.video.play();
                    }catch (e) {
                        console.log(e)
                    }
                },10)
            }
        },
        mounted: function () {

            var video = this.$refs.video;
            if (!video) {
                let timer = setInterval(() => {
                    var video = this.$refs.video;
                    if (video) {
                        clearInterval(timer);

                        this.addeventLister();
                        this.$refs.video.load()

                    }
                }, 500)
            } else {

                this.addeventLister();
                this.$refs.video.load()
            }

        },
        beforeDestroy: function () {

            if (this.getTimeInterval) {
                clearInterval(this.getTimeInterval)
            }
        },
        methods: {

            gettime() {
                if (this.getTimeInterval) {
                    clearInterval(this.getTimeInterval)
                }
                this.getTimeInterval = setInterval(() => {
                    if (this.$refs.video) {
                        try {
                            let currentTime = this.$refs.video.currentTime;
                            if (currentTime && currentTime > 0) {
                                this.currentTime = currentTime;
                                this.updateTime();
                                if (this.$refs.video.paused) {
                                    this.playing = false;
                                    this.error = false;
                                }
                                if (this.$refs.video.error) {
                                    this.playing = false;
                                    this.error = true;
                                }

                            }
                        } catch (e) {
                        }
                    }
                }, 1000)
            },
            pause() {
                try {
                    this.$refs.video.pause()
                } catch (e) {

                }
            },
            play() {
                try {
                    this.$refs.video.play();
                    if (this.muted) {
                        this.$refs.video.muted = true;
                    }
                } catch (e) {

                }
            },

            getVideoTime(time) {
                var hour = parseInt(time / 3600);
                var minute = parseInt((time % 3600) / 60);
                var second = Math.ceil(time % 60);
                var str = [];
                if (hour) {
                    str.push(hour)
                }
                if (minute || minute === 0) {
                    if (minute < 10) {
                        str.push('0' + minute)
                    } else {
                        str.push(minute)
                    }
                }
                if (second || minute === 0) {
                    if (second < 10) {
                        str.push('0' + second)
                    } else {
                        str.push(second)
                    }
                }
                return str.join(':')
            },

            playend() {

                try {
                    if(this.errorTimer){
                        clearTimeout(this.errorTimer)
                    }
                    this.playEndFun &&　this.playEndFun()
                } catch (e) {

                }
            },
            addeventLister() {
                //this.gettime()

                //视频缓冲完成可以播放
                this.$refs.video.oncanplay = () => {
                    if(this.errorTimer){
                        clearTimeout(this.errorTimer)
                    }
                    if (!this.$refs.video) {
                        return
                    }
                    if (this.muted) {
                        this.$refs.video.muted = true;
                    }
                    this.loadding = false;
                    this.error = false;

                    if (this.isfirsttime) {
                        this.isfirsttime = false;
                        try {

                            this.$refs.video.play()
                        } catch (e) {

                        }
                    }

                    this.muted = this.$refs.muted

                }
                //视频时间改变
                // this.$refs.video.ondurationchange = (event) => {
                //     //console.log('视频时间改变',event);
                //     try {
                //         this.error = false;
                //         this.duration = this.$refs.video.duration;
                //         this.currentTime = this.$refs.video.currentTime;
                //         this.updateTime();
                //         if (this.muted) {
                //             this.$refs.video.muted = true;
                //         }
                //     } catch (e) {
                //
                //     }
                // };
                //缺少数据缓存等待中
                this.$refs.video.onwaiting = (event) => {
                    this.loadding = true;
                    this.error = false;
                    if(this.errorTimer){
                        clearTimeout(this.errorTimer)
                    }
                    //console.log('缺少数据缓存等待中',event);
                };
                //视频播放中
                this.$refs.video.onplaying = (event) => {
                    this.loadding = false;
                    this.playing = true;
                    this.error = false;
                    //console.log('视频播放中',event);
                    if (this.muted) {
                        this.$refs.video.muted = true;
                    }
                };
                //视频暂停
                this.$refs.video.onpause = (event) => {
                    //console.log('视频暂停',event);
                    this.playing = false;
                    this.error = false;
                };
                //当媒介资源元素突然为空时（网络错误、加载错误等）运行脚本
                // this.$refs.video.onemptied = () => {
                //     if (this.playing) {
                //         this.error = true;
                //         this.playing = false;
                //         this.errorTimer = setTimeout(()=>{
                //             this.playend();
                //         },1000)
                //     }
                //
                // };
                //播放进度刷新
                // this.$refs.video.ontimeupdate = (event) => {
                //     // console.log(event);
                //     this.currentTime = this.$refs.video.currentTime;
                //     this.updateTime();
                // };

                //播放视频
                this.$refs.video.onplay = (event) => {
                    //console.log('播放视频');
                    this.playing = true;
                    this.error = false;
                    if(this.errorTimer){
                        clearTimeout(this.errorTimer)
                    }
                    if (this.muted) {
                        this.$refs.video.muted = true;
                    }
                };
                // //加载出错
                this.$refs.video.onerror = (event) => {
                    this.error = true;
                    // console.log(event)
                    // this.errorTimer = setTimeout(()=>{
                    //     this.playend();
                    // },2000)
                    //this.playend();

                    //console.log('加载暂停',event);
                };
                //播放结束
                this.$refs.video.onended = (event) => {
                    this.playing = false;
                    this.loadding = false;
                    this.error = false;
                    this.showcontrol = true;
                    this.playend();


                    //console.log('加载暂停',event);
                };
                // this.$refs.video.onseeking = (event) => {
                //     alert('onseeking')
                //     //console.log('加载暂停',event);
                // };
                // this.$refs.video.onseeked = (event) => {
                //     alert('onseeked')
                //     //console.log('加载暂停',event);
                // };


                //onloadedmetadata
                // this.$refs.video.onloadedmetadata = (event) => {
                //     // console.log('onloadedmetadata',event);
                //     // console.log(video.duration)
                //     if(this.errorTimer){
                //         clearTimeout(this.errorTimer)
                //     }
                //
                //     try {
                //         this.duration = this.$refs.video.duration;
                //         this.currentTime = this.$refs.video.currentTime;
                //         this.updateTime();
                //         this.error = false;
                //         if (this.muted) {
                //             this.$refs.video.muted = true;
                //         }
                //     } catch (e) {
                //     }
                // };
            },
            updateTime() {
                this.duration_slider_time = this.getVideoTime(this.duration);
                this.currentTime_slider_time = this.getVideoTime(this.currentTime);
                this.current_slider = (this.currentTime / this.duration * 100).toFixed(2);


                try {
                    var buffered = this.$refs.video.buffered;
                    var bufferedlength = buffered.end(0);
                    this.buffered_slider = (bufferedlength / this.duration * 100).toFixed(2);

                } catch (e) {
                    console.log(JSON.stringify(e))
                }


            },


            reload() {
                this.$refs.video.load()
            }


        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
